import axios from 'axios';
import sanitizeHtml from 'sanitize-html';
import moment from 'moment';
import { addNotification } from './ErrorActions';
import VoilaConfig from '../config';
import * as Sentry from '@sentry/browser';

export const AUTHENTICATED = 'AUTHENTICATED_USER';
export const UNAUTHENTICATED = 'UNAUTHENTICATED_USER';
export const AUTHENTICATION_ERROR = 'AUTHENTICATION_USER_ERROR';

export const USER_INFORMATION = 'USER_INFORMATION';
export const USER_INFORMATION_ERROR = 'USER_INFORMATION_ERROR';

const URL = `${VoilaConfig.API_URL}/jwt-auth/v1/token`;
const userAccountURL = `${VoilaConfig.API_URL}/citizen/account`;

export function parseBirthDate(birth_date) {
  // return nice user facing values for falsy dates
  if (!birth_date) {
    return '';
  }

  if (!parseInt(birth_date, 10)) {
    return 'none';
  }

  return moment(birth_date).format('MM/DD/YYYY').toString();
};

function authenticatedUser(user) {
  return {
    user,
    type: AUTHENTICATED
  };
}

function userInformation(user) {
  return {
    user,
    type: USER_INFORMATION
  };
}

function logOut() {
  return {
    type: UNAUTHENTICATED
  }
}



export function signInAction({ username, password }, history, from='/') {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${URL}`, { username, password });
      dispatch(authenticatedUser(res.data));
      // dispatch(addNotification(`Welcome, ${username}`, 'info'));

      localStorage.setItem('user', JSON.stringify(res.data));
      history.push('/');
      document.location.href=from;

    } catch (error) {
      Sentry.captureException(error);
      let errorSanitized = sanitizeHtml(error.response.data.message);
      return dispatch(addNotification(errorSanitized, 'danger'));
    }
  };
}

export function logOutAction(history) {
  return async dispatch => {
    try {
      localStorage.clear();
      history.push('/');
      document.location.href="/";
      dispatch(logOut())
      //return ;
    }
    catch(err) {
      Sentry.captureException({
        type: 'logout issue',
        error: err
      });
      // console.error(err);
      // return dispatch(addNotification(`We're having problems logging you out`, 'danger'));
    }
  }
}

export function getProfileInformation(token) {
  return async (dispatch) => {
    try {
      let res = await axios({
        method: 'get',
        url: userAccountURL,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return dispatch(userInformation(res.data));
    } catch (error) {
      Sentry.captureException(error);

      dispatch(logOutAction());
      return dispatch({
        type: USER_INFORMATION_ERROR,
        payload: error.message
      });
    }
  };
}

export function updateProfileInformation(token, userData, history) {
  return async (dispatch) => {
    try {
      await axios({
        method: 'PUT',
        url: userAccountURL,
        data: userData,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      history.push('/profile');
      dispatch(addNotification('Profile information updated.', 'success'));

      return dispatch(getProfileInformation(token));
    } catch (error) {
      Sentry.captureException(error);
      dispatch(addNotification(error.message, 'danger'));
    }

    return;
  };
}

export function registerUser(userData, history) {
  return async (dispatch) => {
    try {
      await axios.post(userAccountURL, userData);

      dispatch(addNotification('Thanks for signing up. Please log in.', 'success'));
      history.push('/login');

      return;
    } catch (error) {
      Sentry.captureException(error);
      dispatch(addNotification(error.response.data.message, 'danger'));
    }
  };
}

export function forgotPassword(userData, history) {
  return async (dispatch) => {
    try {
      let res = await axios.post(userAccountURL + '/forgotpassword', userData);
      dispatch(addNotification(res.data, 'success'));

      // dispatch(userInformation(res.data));
      // localStorage.setItem('user', JSON.stringify(res.data));
      history.push('/login');
    } catch (error) {
      Sentry.captureException(error);
      dispatch(addNotification(error.response.data.message, 'danger'));
    }

    return;
  };
}


// WEBPACK FOOTER //
// ./src/actions/UserActions.js